import { css } from "@stubhub/broadway-foundation/css";

export const worldCupRecipes = {
  root: css({
    marginInlineEnd: "-primitives.200",
  }),
  header: css({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingBlockEnd: "primitives.250",
    paddingInlineEnd: "primitives.200",
  }),
  carousel: css({
    paddingInlineStart: "primitives.100",
  }),
  carouselContentRoot: css({
    paddingInlineEnd: "primitives.200",
  }),
};
